import React, { useState, useEffect , useContext} from "react";
import { Container, Input, Link } from "../components/styled.ts";
import { Typography } from "../components/typography/index.tsx";
import { useMobile } from "../hooks/isMobile.tsx";
import { useHistory, useLocation } from "react-router-dom";
import { Header } from "../components/header/index.tsx";
import { Seo } from "../components/seo/index.tsx";
import { subscriberContext } from "../context/subscriberContext.tsx";
import { API_URLS } from "../utils/apiConfig.ts";
import { track, trackOtpVerified } from "../utils/analytics.ts";

const Otp = () => {
  const [otp, setOtp] = useState<string>("");
  const history = useHistory();
  const location = useLocation();
  const { phoneNumber, countryCode } = location.state || {};
  const [timer, setTimer] = useState(30);
  const [isError, setIsError] = useState(false);
  const {setIsError: resetFailure, fetchSubscriberDetails} = useContext(subscriberContext);

  const sendOtp = async (e) => {
    setIsError(false);
    e.preventDefault();
    try {
      setTimer(30);
      setOtp("");
      const response = await fetch(API_URLS.OTP, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          phoneNumber: phoneNumber,
          countryCode: countryCode,
        }),
      });
      if (response.ok) {
        track("otp_sent");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const confirmOtp = async () => {
    try {
      const phoneNumberWithCode = countryCode + phoneNumber;
      const response = await fetch(
        API_URLS.TOKEN,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phoneNumber: phoneNumberWithCode.substring(1),
            otp,
            countryCode: countryCode.substring(1),
          }),
        }
      );
      if (response.status == 200) {
        resetFailure(false);
        const token = response?.headers
          ?.get("Authorization")
          ?.replace("Bearer ", "");
        trackOtpVerified(response.headers);
        // Read redirect before fetchSubscriberDetails strips query params from the URL
        const redirectPath = new URLSearchParams(location.search).get("redirectTo");
        await fetchSubscriberDetails(token);

        if (!redirectPath) {
          history.push({
            pathname: "/watch-list",
            // search: `?tokn=${token}`,
          });
          return;
        }

        history.push({
          pathname: `/${redirectPath.replace(/^\//, "")}`,
          search: `?tokn=${token}`,
        });
        return;
      }
      setIsError(true);
    } catch (error) {
      setIsError(true);
      console.log(error);
    }
  };

  useEffect(() => {
    if (timer === 0) return;
    setTimeout(() => {
      setTimer(timer - 1);
    }, 1000);
  }, [timer]);
  return (
    <>
      <Seo title="Verify OTP | FinQ India" path="/otp" noindex />
      <Header />

      <Container
        width="min(calc(100% - 40px) , 500px)"
        justifyContent="center"
        margin="10px auto"
        column
        gap={"20px"}
        radius="20px"
        padding={"20px"}
        alignItems="center"
      >
        <Typography
          tag="span"
          fontStyle={"normal"}
          background="linear-gradient(165.56deg, #5395FF 39.75%, #D69DFF 58.69%)"
          WebkitBackgroundClip="text"
          WebkitTextFillColor="transparent"
          fontFamily="Neue Montreal"
          fontSize={"27px"}
          fontWeight={500}
          lineHeight={"36.4px"}
          letterSpacing={"0.02em"}
        >
          <span style={{ 
            borderBottom: "2px solid #5395FF",
            paddingBottom: "2px",
            display: "inline-block"
          }}>WhatsApp</span> Verification
        </Typography>
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize={"14px"}
          fontWeight={400}
          lineHeight={"21px"}
          letterSpacing={"0.02em"}
          color="#828282"
          textAlign="center"
        >
          We have sent an OTP to your{" "}
          <Typography
            tag="span"
            fontSize={"15px"}
            fontWeight={"500"}
            background="linear-gradient(165.56deg, #5395FF 39.75%, #D69DFF 58.69%)"
            WebkitBackgroundClip="text"
            WebkitTextFillColor="transparent"
          >
           WhatsApp
          </Typography>{" "}
          on {phoneNumber}
        </Typography>
        <Container
          justifyContent="center"
          margin="10px auto"
          alignItems="center"
          gap={"15px"}
        >
          <Container
            border="1px solid #828282"
            radius="100px"
            padding="10px 0"
            justifyContent="center"
            width={"45%"}
          >
            <Input
              width="100%"
              type="text"
              placeholder="Enter OTP"
              value={otp}
              color="#828282"
              textAlign="center"
              onChange={(e) => {
                if (e.target.value.match(/^[0-9]{0,6}$/)) {
                  setOtp(e.target.value);
                }
              }}
            />
          </Container>

          <Container onClick={confirmOtp} width={"45%"}>
            <Typography
              tag="p"
              fontFamily="Neue Montreal"
              fontSize={"18px"}
              fontWeight={500}
              lineHeight={"19.6px"}
              color="#fff"
              background="#5395FF"
              borderRadius={"100px"}
              padding={"15px 30px"}
              textAlign="center"
              cursor="pointer"
            >
              Verify
            </Typography>
          </Container>
        </Container>
        {isError && (
          <Typography
            tag="p"
            fontFamily="Neue Montreal"
            color="#f22"
            textAlign="center"
            cursor="pointer"
          >
            Invalid OTP
          </Typography>
        )}
        <Typography
          tag="p"
          fontFamily="Neue Montreal"
          fontSize={"14px"}
          fontWeight={400}
          lineHeight={"21px"}
          letterSpacing={"0.02em"}
          color="#828282"
          textAlign="center"
        >
          {timer ? (
            <>Resend OTP in {timer} secs</>
          ) : (
            <>
              Not yet recieved OTP? Click on{" "}
              <Link href="#" onClick={sendOtp} active color="#5395FF">
                Resend OTP
              </Link>
            </>
          )}
        </Typography>
      </Container>
    </>
  );
};

export default Otp;
